






























import Vue, { PropType } from 'vue';
import VueQRCode from '@chenfengyuan/vue-qrcode';
import QRCode from 'qrcode-svg-ts';

import { CodeType } from '@/store/types';
import { Gift } from '../types';

import { appStoreMapper } from '@/store/appstore';
import { formatNumber } from '@/misc';
import { giftsStoreMapper } from '@/modules/gifts/dist/store';

export default Vue.extend({
  name: 'GiftCodeContent',
  components: { VueQRCode },
  props: {
    gift: Object as PropType<Gift>,
    showTitle: String as PropType<string>,
  },
  data: () => ({
    refreshCount: 0,
    qr: '',
    options: {
      width: (window.innerWidth * 2) / 3,
      margin: 2,
      errorCorrectionLevel: 'Q',
    },
  }),
  computed: {
    CodeType() {
      return CodeType;
    },
    innerWidth(): number {
      return this.codeType === CodeType.qr
        ? window.innerWidth - 40
        : (window.innerWidth * 2) / 3;
    },
    qrCodeComputed(): string {
      return this.gift.codeQR || this.gift.code || 'invalid qr-code';
    },
    ...appStoreMapper.mapGetters(['codeType', 'user']),
    ...giftsStoreMapper.mapGetters(['settings']),
  },
  methods: {
    formatNumber,
    generateQrCode() {
      this.qr = new QRCode({
        content: this.qrCodeComputed,
        padding: 2,
        width: (window.innerWidth * 2) / 3,
        height: (window.innerWidth * 2) / 3,
        color: '#000000',
        background: '#ffffff',
        ecl: 'L',
        container: 'svg-viewbox',
        join: true,
      }).svg();
    },
    onClick() {
      this.options.width = (window.innerWidth * 2) / 3;
      this.refreshCount++;
    },
  },
  watch: {
    user: {
      handler() {
        this.generateQrCode();
      },
      deep: true,
      immediate: true,
    },
  },
});
